import { useState } from 'react';
import { useSnackbar } from 'notistack';
import {
  Button, TextField, Dialog, DialogActions,
  DialogContent, IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useApi } from 'lib/contexts/ApplicationState';

export const RoleRequest = () => {
  const { enqueueSnackbar } = useSnackbar();
  const API = useApi();

  const [requestedRole, setRequestedRole] = useState('');
  const [exampleTwitterHandle, setExampleTwitterHandle] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [open, setOpen] = useState(false);

  const submit = async () => {
    try {
      setIsSaving(true);
      await API.createSuggestedRole(requestedRole, exampleTwitterHandle);
      enqueueSnackbar('Your role request was successfully submitted! We\'ll let you know if it was accepted shortly.', {
        variant: 'info',
      });
      setIsSaving(false);
      setOpen(false);
    } catch (err) {
      setIsSaving(false);
      enqueueSnackbar(`There was an error submitting a role request: ${err}`, {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <div className="flex flex-wrap gap-2 items-center border px-2 rounded-md">
        <div>Don&apos;t see a role?</div>
        <Button variant="text" onClick={() => setOpen(true)}>
          Request it here
        </Button>
      </div>
      <Dialog open={open}>
        <div className="p-6">
          <div className="relatve">
            <h1 className="text-lg text-orange font-bold">
              Requst a role
            </h1>
            <div className="absolute right-2 top-2 text-orange">
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <DialogContent>
            <h1 className="m-6">
              Which role should we add?
              <br />
              ex: &quot;NHL Mascot&quot;
            </h1>
            <TextField
              variant="outlined"
              id="name"
              label="Requested role"
              type="text"
              fullWidth
              onChange={(e) => setRequestedRole(e.target.value)}
            />
            <h1 className="m-6">
              Please provide an example social handle from Twitter, Instagram, Tiktok, etc.
              <br />
              ex: &quot;@AvsBernie&quot;
            </h1>
            <TextField
              variant="outlined"
              id="example"
              label="Example handle"
              type="text"
              fullWidth
              onChange={(e) => setExampleTwitterHandle(e.target.value)}
            />
          </DialogContent>
          <DialogActions style={{ margin: '10px' }}>
            <Button onClick={submit} variant="outlined" color="primary" disabled={isSaving || (!requestedRole || !exampleTwitterHandle)}>
              Submit
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};
